import { MapfreAlertComponent } from '../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { MapfreCardComponent } from '../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { HeaderComponent } from '../../modules/mapfre-design-library/src/lib/_components/global-components/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router , RouterModule  } from '@angular/router';
import { User } from '@models/user';
import { UserService } from '../../_services/user.service';
import { SeasonBackgroudDataService } from '../../_services/data-services/season-backgroud-data.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { Subscription } from 'rxjs';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, HeaderComponent, MapfreCardComponent, MapfreAlertComponent],
  selector: 'app-signup',
  templateUrl: './signup.component.html',
})
export class SignupComponent implements OnInit, OnDestroy {
  public previousUrl: any = '';
  user: User = {};
  seasonBackgroundImg: string;
  isAcmic = false;
  isSignupPage = false;
  subscription: Subscription;

  constructor(
    private userService: UserService,
    public router: Router,
    private seasonBackgroudDataService: SeasonBackgroudDataService,
    private acmicService: AcmicService
  ) {
    this.subscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url == '/signup') {
          this.isSignupPage = true;
        } else {
          this.isSignupPage = false;
        }
      }
    });
  }

  goBackAPage() {
    this.router.navigate([this.previousUrl]);
  }
  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.userService.$user.subscribe((user) => {
      this.user = user;
    });
    if (!this.isAcmic) {
      const seasonData = this.seasonBackgroudDataService.getSeasonBackgroundImg();
      this.seasonBackgroundImg = seasonData && seasonData.ma;
    } else {
      const seasonData = this.seasonBackgroudDataService.getSeasonBackgroundImg();
      this.seasonBackgroundImg = seasonData && seasonData.acmic;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    localStorage.removeItem('isCommercialAccount');
  }
}
